var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm_swatches_block",style:({
    'background-color': _vm.backgroundColor,
    'padding-top': `${ _vm.space }px`,
    'padding-bottom': `${ _vm.space }px`
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }